import React, { useEffect, useState } from 'react'

function PaginationCustom({page,current,data, onPaginate, selectedDate }) {
    const [itemsPerPage, setItemsPerPage] = useState(page);
    const [currentPage, setCurrentPage] = useState(current);
    const [currentDate, setCurrentDate] = useState(selectedDate);

    const totalPages = Math.ceil(data.length / itemsPerPage);
    const currentData = data.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Reset currentPage ketika prop `current` berubah
    useEffect(() => {
        setCurrentPage(current);
        setCurrentDate(selectedDate);
    }, [current,selectedDate]);

    // Kirim data yang sudah difilter ke parent setiap kali currentData berubah
    useEffect(() => {
        if (onPaginate) {
            onPaginate(currentData);
        }
    }, [currentData, onPaginate]);

    useEffect(() => {
        if(currentDate !== selectedDate){
            setCurrentDate(selectedDate);
            setCurrentPage(1);
        }
    },[currentDate,selectedDate]);

    // Kirim data yang sudah difilter ke parent setiap kali currentData berubah
    // useEffect(() => {
    //     if (onPaginate){
    //         if(currentDate !== selectedDate){
    //             setCurrentDate(selectedDate);
    //             setCurrentPage(1);
    //         }
    //         onPaginate(currentData);
           
    //     };
    // }, [currentData,onPaginate,currentDate,selectedDate]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

  return (
    <>
        <div className='d-flex justify-content-between'>
            <div className="items-per-page">
                <select
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                    className="form-select"
                >
                    {[10, 25, 50, 100].map((num) => (
                        <option key={num} value={num}>
                            {num}
                        </option>
                    ))}
                </select>
            </div>
            <div className="pagination-buttons">
                <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="btn btn-sm btn-light"
                >
                    &lt;
                </button>
                {[...Array(totalPages)].map((_, index) => (
                    <button
                        key={index}
                        onClick={() => handlePageChange(index + 1)}
                        className={`btn mx-2 btn-sm ${
                            currentPage === index + 1
                                ? "btn-primary"
                                : "btn-light"
                        }`}
                    >
                        {index + 1}
                    </button>
                ))}
                <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="btn btn-sm btn-light"
                >
                    &gt;
                </button>
            </div>
        </div>
    </>
  )
}

export default PaginationCustom